var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 0C43.8768 0 45.9964 0.877974 47.5592 2.44078C49.122 4.00358 50 6.1232 50 8.33333V41.6667C50 43.8768 49.122 45.9964 47.5592 47.5592C45.9964 49.122 43.8768 50 41.6667 50H8.33333C6.1232 50 4.00358 49.122 2.44078 47.5592C0.877974 45.9964 0 43.8768 0 41.6667V8.33333C0 6.1232 0.877974 4.00358 2.44078 2.44078C4.00358 0.877974 6.1232 0 8.33333 0L41.6667 0ZM33.3333 15.1667V9.375H28.5625C24.1875 9.375 21.4375 12.7083 21.4375 17.4792V20.9583H16.6667V26.7292H21.4375V40.625H27.375V26.7292H32.1458L33.3333 20.9583H27.375V18.625C27.375 16.3333 28.5833 15.1667 30.9583 15.1667H33.3333Z",
    fill: "#FFF2E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.1752314daad5cb5d9e6910b16b9da3fa.svg";
export { ForwardRef as ReactComponent };